import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { FormControl, Input, TextField } from '@mui/material';
import HelloUser from './HelloUser';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  sections: ReadonlyArray<{
    title: string;
    url: string;
  }>;
  title: string;
}

export default function DemoHeader(props: HeaderProps) {
  const { sections, title } = props;
  const [name, setName] = React.useState(null);
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Typography
          component="h2"
          variant="h5"
          color="inherit"
          align="center"
          fontWeight={700}
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <HelloUser/>
        <Typography
          id="login-name"
          component="h2"
          variant="h6"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {name ? `Hello, ${name}` : ''}
        </Typography>
        <div style={{
          display: "flex",
          gap: "10px"
        }}>
        <Button variant="outlined" size="small" onClick={() => navigate('/sign-up')}>
          Sign up
        </Button>
        <Button variant="outlined" size="small" onClick={() => navigate('/login')}>
          Login
        </Button>
        </div>
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{ justifyContent: 'space-between', overflowX: 'auto' }}
      >
        {sections.map((section) => (
          <Link
            color="inherit"
            noWrap
            key={section.title}
            variant="body2"
            href={section.url}
            sx={{ p: 1, flexShrink: 0 }}
          >
            {section.title}
          </Link>
        ))}
      </Toolbar>
    </React.Fragment>
  );
}
